import React from 'react';
import { FaEdit, FaCertificate } from 'react-icons/fa';
import { Link } from 'react-router-dom';

export const ProDashProfileTab = ({ profile, professionalType }) => (
  <div className="bg-white rounded-xl shadow-sm p-6">
    <div className="flex items-center justify-between mb-6">
      <h3 className="font-bold text-gray-900">Your Profile</h3>
      <Link
        to="/professionals/edit-profile"
        className="flex items-center gap-2 px-4 py-2 bg-blue-600 text-white rounded-lg hover:bg-blue-700 text-sm"
      >
        <FaEdit />
        Edit Profile
      </Link>
    </div>

    <div className="grid md:grid-cols-2 gap-6">
      <div>
        <h4 className="font-medium text-gray-700 mb-3">Basic Information</h4>
        <div className="space-y-3">
          <div>
            <p className="text-sm text-gray-500">Name</p>
            <p className="text-gray-900">{profile?.name}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Email</p>
            <p className="text-gray-900">{profile?.email}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Phone</p>
            <p className="text-gray-900">{profile?.phone || 'Not provided'}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Location</p>
            <p className="text-gray-900">{profile?.location || 'Not provided'}</p>
          </div>
        </div>
      </div>

      <div>
        <h4 className="font-medium text-gray-700 mb-3">Professional Details</h4>
        <div className="space-y-3">
          <div>
            <p className="text-sm text-gray-500">Type</p>
            <p className="text-gray-900">{professionalType}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Company</p>
            <p className="text-gray-900">{profile?.company || 'Not provided'}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Years Experience</p>
            <p className="text-gray-900">{profile?.years_experience || 'Not provided'}</p>
          </div>
          <div>
            <p className="text-sm text-gray-500">Hourly Rate</p>
            <p className="text-gray-900">{profile?.hourly_rate ? `$${profile.hourly_rate}` : 'Not set'}</p>
          </div>
        </div>
      </div>
    </div>

    {profile?.bio && (
      <div className="mt-6">
        <h4 className="font-medium text-gray-700 mb-2">Bio</h4>
        <p className="text-gray-700">{profile.bio}</p>
      </div>
    )}

    {profile?.certifications?.length > 0 && (
      <div className="mt-6">
        <h4 className="font-medium text-gray-700 mb-2">Certifications</h4>
        <div className="flex flex-wrap gap-2">
          {profile.certifications.map((cert) => (
            <span key={cert} className="flex items-center gap-1 px-3 py-1 bg-amber-50 text-amber-700 rounded-full text-sm">
              <FaCertificate />
              {cert}
            </span>
          ))}
        </div>
      </div>
    )}
  </div>
);
